// libs
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import escapeRegExp from 'lodash/escapeRegExp';

// constants
import { DEVICE_TYPE, DEFAULT_INITIALS, PAGE_TYPE } from 'shared/components/Header/constants';

// helpers
import { stripAccents } from 'shared/helpers/utils/string';
import { getPLPFilterParams } from 'shared/helpers/utils/url';

interface IGenerateTrackingForMMProps {
  url: string;
  channel: string;
  level: string;
  name: string;
  title: string;
  position: string;
  isCuration: string;
  filterData?: string;
  sort?: string;
}

export const getAllBrands = (data: any) => {
  const brandIds = [];
  return get(data, 'children', []).reduce((acc, subCategory) => {
    const brands = subCategory.children
      .filter((child) => brandIds.indexOf(child.id) === -1)
      .map((child) => {
        brandIds.push(child.id);
        return {
          title: child.title,
          url: child.url,
        };
      });

    return [...acc, ...brands];
  }, []);
};

export const getFilteredBrands = (filterText = '', brands: any) => {
  if (filterText.trim().length === 0) {
    return brands;
  }

  const filterRegExp = new RegExp(`${escapeRegExp(filterText)}`, 'i');

  return brands.filter((brand: { title: string }) => filterRegExp.test(stripAccents(brand.title)));
};

export const bucketizeBrands = (brands: any): { [key: string]: any } => {
  return brands.reduce((bucket, brand) => {
    let char: string = brand.title.substring(0, 1).toUpperCase();

    if (!DEFAULT_INITIALS.includes(char)) {
      char = DEFAULT_INITIALS[0];
    }

    if (bucket[char] === undefined) {
      bucket[char] = [];
    }

    bucket[char].push(brand);
    return bucket;
  }, {});
};

export const isMwebMenu = ({ device = '' }: { device: string }) =>
  isEmpty(device) || String(device).toLocaleLowerCase() === DEVICE_TYPE.MOBILE;

export const isDwebMenu = ({ device = '' }: { device: string }) =>
  isEmpty(device) || String(device).toLocaleLowerCase() === DEVICE_TYPE.DESKTOP;

export const generateTrackingUrlForMegaMenu = ({
  url,
  channel,
  level,
  name,
  title,
  position,
  isCuration,
  filterData,
  sort,
}: IGenerateTrackingForMMProps) => {
  try {
    const params = new URLSearchParams();

    if (isCuration) {
      params.set(
        'intcmp',
        `${PAGE_TYPE.CURATION},${channel},${position},${name || title || ''}`
          .replace(/ /g, '-')
          .toLowerCase()
      );
    } else {
      params.set('root', `nav_${level}`);
      params.set(
        'ptype',
        `${PAGE_TYPE.LISTING},${channel},${position},${name || title || ''}`
          .replace(/ /g, '-')
          .toLowerCase()
      );
    }

    if (!isEmpty(filterData) || !isEmpty(sort)) {
      params.set('f', getPLPFilterParams(filterData, sort));
    }

    if (url.indexOf('?') > -1) {
      return `${url}&${params.toString()}`;
    }
    return `${url}?${params.toString()}`;
  } catch (err) {
    return url;
  }
};
